import styled from 'styled-components'

const Content = styled('div')`
  margin: auto;
  height: 100%;
  width: 100%;
  background: #fff;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  position: relative;
`

export default Content
